import QuantityPricingToolsBase from '../_utils/tools/quantity-pricing-tools';

// -----------------------------------------------------------
//  QuantityPricingTools Wrapper
// -----------------------------------------------------------

class QuantityPricingTools extends QuantityPricingToolsBase {
  constructor(product, unitPrices = null) {
    super({
      useSetsWherePossible: product.show_quantity_dropdown,
      productSetCopies: product.set_copies,
      unitPrices:
        (unitPrices && unitPrices.prices.unit_prices) ||
        ((product.prices || {}).prices || {}).unit_prices,
      perPagePrices: ((product.prices || {}).prices || {}).per_page_prices,
    });

    this.isCard = product.is_card;
    this.extraPagePricesPerDeliveryOption =
      product.extra_page_prices_per_delivery_option || {};
  }

  generateOptions() {
    const productName = (() => {
      if (this.isCard) {
        return 'card';
      }
    })();

    return super.generateOptions(productName);
  }

  getExtraPagePrice(deliveryOption) {
    return deliveryOption
      ? this.extraPagePricesPerDeliveryOption[deliveryOption.key]
      : (this.perPagePrices || {}).extra_page_price;
  }
}

export default QuantityPricingTools;
